import InsightsCards from '../insights-cards/InsightsCards';
import { useTranslation } from 'react-i18next';
import RefreshButton from '@customer/components/inputs/refresh-button/RefreshButton';
import { QueryTag } from '@customer/store/api';
import DashboardSection from '../dashboard-section/DashboardSection';
import { StatsScenario } from '@customer/store/apis/scenariosApi';
import { TagDescription } from '@reduxjs/toolkit/query';

const tagsToClearOnRefresh: TagDescription<QueryTag>[] = [
  QueryTag.Health,
  { type: QueryTag.InteractionsSummary, id: 'SITE' },
  {
    type: QueryTag.ScenariosTimeSeries,
    id: StatsScenario.VehicleInteractionsByTimeRange,
  },
  {
    type: QueryTag.ScenariosTimeSeries,
    id: StatsScenario.GeofenceInteractionsByTimeRange,
  },
];

export function SiteInsights() {
  const { t } = useTranslation();

  return (
    <DashboardSection
      title={t('CasInsights')}
      action={<RefreshButton tagsToClear={tagsToClearOnRefresh} />}
    >
      <InsightsCards />
    </DashboardSection>
  );
}

export default SiteInsights;
